import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

///装车单复核列表数据
export const GetPutOnCarLoadingReviewDataList = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarLoadingReviewDataList`, { ...params }).then(res => res.data);
};


///装车单复核图片信息
export const GetPutOnCarLoadingReviewImageList = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarLoadingReviewImageList`, { ...params }).then(res => res.data);
};



//预览照片
export const GetLoadCarInfoImages = params => {
    return axios.get(`${BaseApiUrl}/PutOnCar/GetLoadCarInfoImages`, { params: params });
};



///装车单复核提交
export const PutOnCarReviewSubmit = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/PutOnCarReviewSubmit`, { ...params }).then(res => res.data);
};


///装车单复核列表数据
export const GetPutOnCarLoadingReviewBoxInfo = params => {
    return axios.post(`${BaseApiUrl}/PutOnCar/GetPutOnCarLoadingReviewBoxInfo`, { ...params }).then(res => res.data);
};



